export var InputVariant;
(function (InputVariant) {
    InputVariant["Standard"] = "standard";
    InputVariant["Outline"] = "outline";
    InputVariant["Filled"] = "filled";
})(InputVariant || (InputVariant = {}));
